import { Refund } from 'store/api/refund';
import { formatPrice } from 'utils/helpers';

export const getRefundFields = (value: Refund) => {
  const result = [
    {
      title: 'Return to Inventory',
      value: value.isReturnToInventory ? 'Yes' : 'No',
    },
    {
      title: 'Amount',
      value: formatPrice(
        value?.refundPayments?.reduce(
          (acc, curr) => acc + Number(curr.amount),
          0
        )
      ),
    },
    {
      title: 'Total Refund Amount',
      value: formatPrice(value?.totalRefundPayments),
    },
    {
      title: 'Total Processing Fee Amount',
      value: formatPrice(value?.totalRefundProcessingFee),
    },
  ];

  const tipAmount = value?.refundPayments?.reduce(
    (acc, curr) => acc + (Number(curr.tip) || 0),
    0
  );

  if (tipAmount) {
    result.splice(2, 0, {
      title: 'Tip',
      value: formatPrice(tipAmount),
    });
  }

  if (value?.storage?.name) {
    result.splice(1, 0, {
      value: value.storage.name,
      title: 'Return Storage Name',
    });
  }

  return result;
};
